export enum BusinessTypes {
    All = "all",
    Konsulentvirksomhet = "konsulentvirksomhet",
    Programmeringstjenester = "programmeringstjenester",
    AndreTjenester = "andreTjenester"
}